import { IconMail, IconMailOpened, IconPhone } from "@tabler/icons-react";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { IconLocation } from "@tabler/icons-react";
import axios from "axios"
import { useState } from "react";
import toast from 'react-hot-toast'
import { useAuth } from "../context/authContext";
import { useNavigate } from "react-router-dom";



function Signin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://gearup-car-hire.onrender.com/api/user/signin", {
        email, password
      })
      console.log(response)
      toast.success("login Sucessfully")
      navigate("/")

      const token = 'your-auth-token';
      login(token);
      
    } catch (error) {
      console.error(error);
      toast.error("Invalid Credentials");
    }
  };

  return (
    <>
      <section className="contact-page">
        <HeroPages name="Sign in" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>Login Your Account</h2>
              <p>
                A multifaceted professional skilled in multiple fields of
                research, development as well as a learning specialist. Over 15
                years of experience.
              </p>
              <a href="/">
                <IconPhone /> &nbsp; (123) 456-7869
              </a>
              <a href="/">
                <IconMail /> &nbsp; carrental@carmail.com
              </a>
              <a href="/">
                <IconLocation />
                &nbsp; Belgrade, Serbia
              </a>
            </div>
            <div className="contact-div__form">
              <form onSubmit={handleSubmit}>
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input type="email" placeholder="youremail@example.com" value={email} onChange={(e)=>setEmail(e.target.value)} name="email"></input>

                <label htmlFor="password">
                  Password <b>*</b>
                </label>
                <input type="password" placeholder="Enter your Password" value={password} onChange={(e)=>setPassword(e.target.value)} name="password"></input>

                <button type="submit">
                  <IconMailOpened />
                  &nbsp; Sign In
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <IconPhone width={40} height={40} />
                <h3>(123) 456-7869</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Signin;
